import experienceData from '../../data/experience';
import Reveal from '../Reveal';
import SectionHeading from '../SectionHeading';

const Experience = () => {
  return (
    <section className='bg-white px-5 py-20 md:px-10 lg:px-20' id='experience'>
      <div className='max-w-[900px] mx-auto'>
        <SectionHeading number='03 — Career' title='Experience' />

        <div className='flex flex-col gap-8'>
          {experienceData.roles.map((role, index) => (
            <Reveal key={role.id} delay={index * 100}>
              <div className='group border border-ink/10 rounded-2xl p-7 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:border-accent/30 hover:shadow-[0_24px_48px_-24px_rgba(23,23,23,0.2)]'>
                <div className='flex flex-col md:flex-row md:items-baseline md:justify-between gap-1 mb-1'>
                  <h3 className='text-xl font-semibold text-ink'>
                    {role.title}
                  </h3>
                  <span className='font-mono text-xs tracking-wide text-ink/50'>
                    {role.dates}
                  </span>
                </div>
                <p className='text-accent font-medium mb-1'>
                  {role.company}{' '}
                  <span className='text-ink/40 font-normal'>
                    {role.companyNote}
                  </span>
                </p>
                {role.subtitle && (
                  <p className='text-sm text-ink/50 mb-5'>{role.subtitle}</p>
                )}

                <ul className={`space-y-4 leading-7 text-ink/75 ${role.subtitle ? '' : 'mt-5'}`}>
                  {role.bullets.map((bullet, bulletIndex) => (
                    <li
                      key={bulletIndex}
                      className='pl-5 relative before:content-[""] before:absolute before:left-0 before:top-[0.6em] before:h-1.5 before:w-1.5 before:rounded-full before:bg-accent/60'
                    >
                      {bullet}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
